/* Love N Care — site search overlay + recent searches.
   The type-ahead itself is Dawn's predictive-search.js (fetch, debounce, keyboard, ARIA);
   this file only opens/closes the overlay (snippets/lnc-search-overlay.liquid), keeps a
   small "recent searches" list in localStorage, and mirrors the typed term into the
   "See all results for …" row between fetches. */
(function () {
  var KEY = 'lnc_recent_searches';
  var MAX = 6;
  var overlay = null;
  var isOpen = false;
  var lastFocus = null;

  /* ---------- recent searches ---------- */
  function readRecent() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v.filter(function (t) { return typeof t === 'string' && t.trim(); }) : [];
    } catch (e) { return []; }
  }
  function writeRecent(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) { /* private mode */ }
  }
  function remember(term) {
    term = String(term || '').trim().replace(/\s+/g, ' ');
    if (!term || term.length > 80) return;
    var lower = term.toLowerCase();
    var list = readRecent().filter(function (t) { return t.toLowerCase() !== lower; });
    list.unshift(term);
    writeRecent(list);
  }
  function searchUrl(term) {
    var base = (window.routes && window.routes.search_url) || '/search';
    return base + '?q=' + encodeURIComponent(term) + '&options%5Bprefix%5D=last';
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function renderRecent(root) {
    var wrap = root.querySelector('[data-lnc-recent]');
    var list = root.querySelector('[data-lnc-recent-list]');
    if (!wrap || !list) return;
    var items = readRecent();
    wrap.hidden = items.length === 0;
    list.innerHTML = items.map(function (t) {
      return '<a href="' + searchUrl(t) + '" class="lnc-so__chip lnc-so__chip--recent" data-lnc-search-term="' + escapeHtml(t) + '">' +
        '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/></svg>' +
        escapeHtml(t) + '</a>';
    }).join('');
  }

  /* ---------- overlay ---------- */
  function getOverlay() {
    if (!overlay || !document.body.contains(overlay)) overlay = document.querySelector('[data-lnc-search-overlay]');
    return overlay;
  }
  function setToggles(expanded) {
    document.querySelectorAll('[data-lnc-search-toggle]').forEach(function (b) {
      b.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }
  function openOverlay() {
    var o = getOverlay();
    if (!o) return;
    var input = o.querySelector('[data-lnc-search-input]');
    lastFocus = document.activeElement;
    renderRecent(o);
    o.hidden = false;
    void o.offsetWidth;                         // commit display before the transition class
    o.classList.add('is-open');
    document.documentElement.classList.add('lnc-so-lock');
    setToggles(true);
    isOpen = true;
    if (input) {
      input.focus();                            // synchronous: iOS only raises the keyboard inside the tap
      if (input.value) input.select();          // reopening: typing replaces the old term, Dawn re-shows its results on focus
    }
  }
  function closeOverlay(restoreFocus) {
    var o = getOverlay();
    if (!o || !isOpen) return;
    isOpen = false;
    o.classList.remove('is-open');
    document.documentElement.classList.remove('lnc-so-lock');
    setToggles(false);
    var input = o.querySelector('[data-lnc-search-input]');
    if (input) input.blur();
    setTimeout(function () { if (!isOpen) o.hidden = true; }, 280);
    if (restoreFocus !== false && lastFocus && typeof lastFocus.focus === 'function') {
      try { lastFocus.focus({ preventScroll: true }); } catch (e) { /* noop */ }
    }
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-lnc-search-toggle]') : null;
    if (t) {
      e.preventDefault();
      if (isOpen) closeOverlay(); else openOverlay();
      return;
    }
    var drawerPill = e.target.closest('[data-lnc-drawer-search]');
    if (drawerPill) {
      e.preventDefault();
      var drawerClose = document.querySelector('[data-lnc-drawer] .lnc-drawer__close');
      if (drawerClose) drawerClose.click();
      openOverlay();
      return;
    }
    var o = getOverlay();
    if (o && o.contains(e.target)) {
      if (e.target.closest('[data-lnc-search-close]')) { e.preventDefault(); closeOverlay(); return; }
      if (e.target.closest('[data-lnc-recent-clear]')) { writeRecent([]); renderRecent(o); return; }
    }
    /* Remember what was searched for: popular/recent chips, and any suggestion that
       links to the results page. Product/collection links are destinations, not terms. */
    var a = e.target.closest('a[data-lnc-search-term], [data-predictive-search] a');
    if (a) {
      var term = a.getAttribute('data-lnc-search-term');
      if (!term) {
        try {
          var u = new URL(a.getAttribute('href'), location.origin);
          var base = (window.routes && window.routes.search_url) || '/search';
          if (u.pathname === base) term = u.searchParams.get('q');
        } catch (err) { /* ignore */ }
      }
      if (term) remember(term);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) closeOverlay();
  });

  /* Enter / the arrow button in any search form */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[role="search"]')) return;
    var q = f.querySelector('input[name="q"]');
    if (q) remember(q.value);
  });

  /* Mirror the term into "See all results for …" while the next fetch is in flight
     (Dawn only refreshes that row when new results render). */
  document.addEventListener('input', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('predictive-search input[type="search"]')) return;
    var host = input.closest('predictive-search');
    host.querySelectorAll('[data-lnc-ps-term]').forEach(function (el) { el.textContent = input.value.trim(); });
  });

  /* Landing on the results page (from anywhere) counts as a search */
  (function rememberFromUrl() {
    var base = (window.routes && window.routes.search_url) || '/search';
    if (location.pathname !== base) return;
    var q = new URLSearchParams(location.search).get('q');
    if (q) remember(q);
  })();

  /* Theme editor re-renders the header: drop stale references + any body lock */
  document.addEventListener('shopify:section:load', function () {
    overlay = null; isOpen = false;
    document.documentElement.classList.remove('lnc-so-lock');
  });
})();
